// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"da2a476c","148":"db9d2cbd","305":"96cbdcdf","432":"3212ff91","546":"a1e0300c","663":"2e1cfe6f","859":"23866ead","997":"5989435c"}[chunkId] + ".chunk.js";
};